import ComponentModule from "@eisinc/Overrides/Components/CustomerAddressFormFields";

export * from "@eisinc/Overrides/Components/CustomerAddressFormFields";

export default ComponentModule;
